import React from 'react';
import { Switch, Route } from 'react-router';
import Home from './home';
import useAuthListener from 'hooks/useAuthListener';
import ProtectedRoute from 'components/protectedRoute';
import { useSelector } from 'react-redux';
import { AppState } from 'store';
import Login from './login';
import { Box } from 'rebass';
import Project from './project';
import LowerTooltip from 'components/lowerTooltip';
import Admin from './admin';
import AppHeader from 'components/shell/AppHeader';
import AppFooter from 'components/shell/AppFooter';
import Portal from './portal';
import useAuth from 'hooks/useAuth';
import useThemeColours from 'hooks/useThemeColours';
import { useLabelNamesListener } from 'hooks/useLabelNames';

/**
 * Applies the customer's colours and storage-label names once someone is signed in
 * (the rules allow no reads before that).
 */
const ThemeColours = () => {
  useThemeColours();
  useLabelNamesListener();
  return null;
};

const Router = () => {
  useAuthListener();
  const { user } = useSelector((state: AppState) => state.auth);
  const { tooltip, tooltipToggle } = useSelector((state: AppState) => state.util);
  const { role } = useAuth();

  // Task #1: a client login only ever sees its own download page, whatever address it opens.
  if (user && role === 'client') return <Portal />;

  return (
    <Box>
      {user && (
        <>
          <ThemeColours />
          <AppHeader />
          <Box height={64} />
        </>
      )}
      <LowerTooltip tooltip={tooltip} toggled={tooltipToggle} />
      <Switch>
        <Route exact path="/login" component={Login} />
        <ProtectedRoute
          isAuthenticated={!!user}
          isAdminRoute={true}
          authenticationPath="/login"
          path="/portal"
          component={Portal}
        />
        <ProtectedRoute
          isAuthenticated={!!user}
          exact
          authenticationPath="/login"
          path="/project/:id"
          component={Project}
        />
        <ProtectedRoute
          isAuthenticated={!!user}
          isAdminRoute={true}
          authenticationPath="/login"
          path="/admin"
          component={Admin}
        />
        <ProtectedRoute
          isAuthenticated={!!user}
          authenticationPath="/login"
          path="/"
          component={Home}
        />
      </Switch>
      {user && <AppFooter />}
    </Box>
  );
};

export default Router;
